import CartService from "../services/CartService";

/**
 * Handles the removal of promotional gift products from the cart.
 *
 * This class is responsible for reading gift variant IDs from `localStorage`
 * and updating the cart accordingly via the CartService.
 */
export default class RemoveGiftsHandler {
  constructor() {
    this.cartService = new CartService();
  }

  /**
   * Removes promotional gift items from the cart.
   *
   * Reads variant IDs stored in `localStorage` under the key `"removeGifts"`,
   * and sets their quantity to 0 using the `CartService`. Clears the localStorage
   * key after removal. Logs and rethrows any errors encountered during the process.
   * Finally, reload the page to ensure that the gift product is removed from the current cart.
   *
   * @async
   * @throws {Error} If an error occurs while updating the cart.
   */
  async removeGift() {
    if (localStorage.getItem("removeGifts")) {
      const giftsToRemove = JSON.parse(localStorage.getItem("removeGifts"));
      for (const variantId of giftsToRemove) {
        try {
          await this.cartService.updateCart(variantId, 0);
          localStorage.removeItem("removeGifts");
          location.reload();
        } catch (error) {
          console.error("Error with variantId: ", variantId, error);
          throw error;
        }
      }
    }
  }
}